/** @format */

import { surveyUrl } from "../Config/Url";
import axios from "axios";

export const surveyService = {
  getAll,
  create,
  update,
  remove,
};

async function getAll() {
  return axios
    .put(`${surveyUrl}/search`, { pageIndex: 0, pageSize: 100 })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create(data) {
  return axios
    .post(`${surveyUrl}`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function update(id, data) {
  return axios
    .put(`${surveyUrl}/${id}`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function remove(id) {
  return axios
    .delete(`${surveyUrl}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}
